import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, useSearchParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../components/imports'

import { WEBROOT, APP_NAME } from '../constants/general'

import { Context } from '../class/Context'

import User from '../class/User'

import Func from '../class/Func'

function ValiderEmail() {
    
    const [loading, setLoading] = useState(true)

    const [ get_params ] = useSearchParams()

    const context = useContext(Context)

    const navigate = useNavigate()

    const [flash, setFlash] = useState('')

    const validate = async (email, token) => {

        if(email !== null && token !== null){

            const results = await User.validerEmail(email, token)
    
            if(results.success){
    
                setFlash({message: results.message, type: "succes"})
    
            }else{

                setFlash({message: results.message, type: "error"})
                            
            }

            setLoading(false)

        }else{

            setLoading(false)

            setFlash({message: "Impossible de valider votre adresse email avec ce lien.", type: "error"})

        }
    
        
    
    }

    useEffect(() => {

        document.title = "Validation de l'adresse email - " + APP_NAME

        let email = get_params.get("email")
        let token = get_params.get("token")

        validate(email, token)


    }, [])

    return (

        <div>

            <Header />

            <div className="register pos-r content">

                <HeaderBox />

                <div className='pos-r m_mt_40'>

                    <div className="col-4 m0a pt80 pb80 ta-center m_p20">

                        <h1 className='mb30 fw4'>Adresse mail validée avec succès</h1>

                        { flash !== '' && <p className={ flash.type + " fz08 mb0"}>{ flash.message }</p>}

                        <Link to={'/mon-profile/parametres'} className='mt40 btn bg4 cl1'>Accéder profil</Link>

                        {

                            loading

                            &&

                            <div className='flex jc-center mt50 mb50'><div className="lds-dual-ring col"></div></div>

                        }

                    </div>

                </div>

            </div>

            <Footer />

        </div>
        
    )

}

export default ValiderEmail